import { render, staticRenderFns } from "./Extractions.vue?vue&type=template&id=50b11728&"
import script from "./Extractions.vue?vue&type=script&lang=js&"
export * from "./Extractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports